var map = {
	"./de-DE/classDetails.json": [
		89954,
		8664
	],
	"./en-AU/classDetails.json": [
		79855,
		4326
	],
	"./en-CA/classDetails.json": [
		69025,
		6130
	],
	"./en-GB/classDetails.json": [
		36239,
		3449
	],
	"./en-US/classDetails.json": [
		88515,
		2691
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 62791;
module.exports = webpackAsyncContext;